import * as React from "react";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useUserContext } from "../../user-provider";
import PdfViewer from "../../utility/PdfViewer";
import PdfViewerModal from "../../utility/PdfViewerModal";
import { handlePdfPreviewScreenOpen } from "../../utility/PdfViewerModal";
import { useUtilityContext } from "../../utility-provider";
import { apiRequest } from "../../api/ApiCall";
import {
    setObjDrawing,
    setDrawingPdf,
    setTargetFileType,
    setDeleteFile,
} from "../../features/drawingSlice";
import {
    upsertDrawingPathParam,
} from "../subPage/Drawing/DrawingFunction";
import {
    Box,
    Button,
    Grid,
    IconButton,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from "@mui/material";
import { LOCAL_CONSTANT } from "../Const";
import { userLogging } from "../../utility/firestore";
import ObstaclesEtc from "../subPage/Drawing/ObstaclesEtc";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import {
    getFileMetadata,
    uploadFile,
    deleteUploadFile,
} from "../../utility/storage";
import MessageDialog from "../components/MessageDialog";
import ConfirmDialog from "../components/ConfirmDialog";
import { DeleteConfirmationModal } from "../ResearchReport/DeleteConfirmationModal";
import { setPermissionFunc } from "../components/PermissionFunc";
import { staffName } from "../Common";
import {
    DrawingStringTypeList,
    initDrawingCommentTextFieldObj,
} from "../../data/type";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import DeficiencyCommentRegistModal from "../components/DeficiencyCommentRegistModal";
import {
    chatBubbleErrorSx,
    chatBubbleIconSx,
    iconHover,
} from "../components/ChatBubbleAndEditIconStyle";
import { commonFileDownload } from "../../page/Common";
import dayjs from "dayjs";

const headerCell = (type: string) => {
    return{
        backgroundColor: '#D9D9D9',
        fontSize: '12px',
        color: 'black',
        borderBottom: '1px solid black',
        fontWeight: 'Bold',
        width: type === 'FILE_NAME' ? '40%'
        : type === 'UPLOAD_DATE' ? '15%' 
        : type === 'UPLOADER' ? '15%' 
        : '6%',
        textAlign: type === 'OTHER' ? 'center' : 'start'
    }
};

const excelListTemplate = () => {
    return [
        JSON.parse(JSON.stringify(init_layout)),
        JSON.parse(JSON.stringify(init_placement)),
        JSON.parse(JSON.stringify(init_designer_placement)),
    ];
};

const init_layout = {
    recreate: "none",
    file_name: LOCAL_CONSTANT.LABEL.LAYOUT_DIAGRAM,
    uploadDate: "",
    uplowder: "",
    file_path: "",
    target: "layout",
};
const init_placement = {
    recreate: "none",
    file_name: LOCAL_CONSTANT.LABEL.PLACEMENT_DIAGRAM,
    uploadDate: "",
    uplowder: "",
    file_path: "",
    target: "placement",
};
const init_designer_placement = {
    recreate: "none",
    file_name: LOCAL_CONSTANT.LABEL.DESIGNER_PLACEMENT_DIAGRAM,
    uploadDate: "",
    uplowder: "",
    file_path: "",
    target: "designer_placement",
};

export interface resultDialogProps {
    props: {
    };
};

const Drawing: React.FC<resultDialogProps> = ({ props }) => {
    const objDrawing = useAppSelector((state) => state.drawing.obj);
    //不備コメントリスト
    const listDeficiencyComment = useAppSelector((state) => state.deficiencyComment);

    //ユーザーIDを取得
    const [userId, setUserId] = useState<string>("");
    const [userType, setUserType] = useState("");
    const user = useUserContext();

    const utilityCtx = useUtilityContext();

    const [message, setMessage] = React.useState<string>("");
    const [messageDialogOpen, setMessageDialogOpen] =
        React.useState<boolean>(false);
    const [hasButton, setHasButton] = React.useState<boolean>(false);

    //プレビュー
    const previewPdfPath = useAppSelector((state) => state.drawing.pdfPath);
    // ファイルアップロード対象
    const targetFileType = useAppSelector(
        (state) => state.drawing.targetFileType
    );
    // ファイルデリート対象
    const objDeleteFile = useAppSelector((state) => state.drawing.deleteFile);

    //候補地NOと枝を取得
    const objLongPageParam = useAppSelector((state) => state.longPage.param);
    //タスクIDを取得するため
    const objLocationBase = useAppSelector(
        (state) => state.longPage.locationBase
    );

    const dispatch = useAppDispatch();

    //モーダル開閉フラグ(削除確認)
    const [deletePdfConfModalOpen, setDeletePdfConfModalOpen] = useState(false);
    const [deleteLayConfModalOpen, setDeleteLayConfModalOpen] = useState(false);
    //不備コメントモーダルラベル名
    const [labelNameStr, setLabelNameStr] = useState<string>("");
    //不備コメントモーダル開閉フラグ
    const [deficiencyComentModalFlag, setDeficiencyComentModalFlag] =
        useState(false);
    //不備コメントモーダル内、TextFieldのコメント
    const [drawingCommentTextFieldObj, setDrawingCommentTextFieldObj] =
        useState<DrawingStringTypeList>(initDrawingCommentTextFieldObj);
    //LAYファイルアップロード確認モーダル
    const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);

    const [excelList, setExcelList] = useState<any[]>(excelListTemplate);
    const [layRfcFileList, setLayRfcFileList] = useState<any[]>([]);
    const [layRrFileList, setLayRrFileList] = useState<any[]>([]);
    const [ulType, setUlType] = useState<string>("");

    //モーダル開閉フラグ(PDFプレビュー)
    const [pdfPreviewModalFlag, setPdfPreviewModalFlag] = React.useState(false);

    useEffect(() => {
        if (excelList.length > 0 && objDrawing) {
            if (objDrawing.layout_file_path !== "") {
                whiteExcelList(
                    0,
                    objDrawing.layout_file_path,
                    objDrawing.layout_file_user
                );
            }
            if (objDrawing.placement_file_path !== "") {
                whiteExcelList(
                    1,
                    objDrawing.placement_file_path,
                    objDrawing.placement_file_user
                );
            }
            if (objDrawing.designer_placement_file_path !== "") {
                whiteExcelList(
                    2,
                    objDrawing.designer_placement_file_path,
                    objDrawing.designer_placement_file_user
                );
            }
            setLayRfcFileList(objDrawing.lay_file_rfc_path);
            setLayRrFileList(objDrawing.lay_file_rr_path);
        }
    }, [objDrawing]);

    const handlePreviewChange = (pdfPath: string) => {
        //表示中のPDFレコードを押下時非表示
        if (pdfPath !== "") {
            const path =
                "gs://" +
                process.env.REACT_APP_FIREBASE_STORAGE_BUCKET +
                "/" +
                objLongPageParam.planAreaId +
                "/" +
                objLongPageParam.branch +
                pdfPath;
            if (previewPdfPath === path) {
                dispatch(setDrawingPdf(""));
            } else {
                dispatch(setDrawingPdf(path));
            }
        }
    };

    //PDFプレビューモーダルオープン
    const handlePdfPreviewModalOpen = (pdfPathParam: string) => {
        setPdfPreviewModalFlag(true);
        dispatch(setDrawingPdf(pdfPathParam));
    };

    const closeMessageDialog = () => {
        setMessage("");
        setHasButton(false);
        setMessageDialogOpen(false);
    };

    //PDFファイルアップロードボタン押下
    const handleClickPdfFile = (target: string) => {
        dispatch(setTargetFileType(target));
        const fileElem = document.getElementById("drawingFileElem");
        if (fileElem) {
            fileElem.click();
        }
    };

    //LAYファイルアップロードボタン
    const handleClickLayFile = (type: string) => {
        setUlType(type);
        //既にファイルがULされている場合確認ダイアログを出す
        if((type === "RFC" && layRfcFileList.length > 0) || 
            (type === "RR" && layRrFileList.length > 0)
        ) {
            setConfirmDialogOpen(true);
        } else {
            handleOkResult();
        }
    };

    const handleOkResult = () => {
        const fileElem = document.getElementById("drawingLayFileElem");
        if (fileElem) {
            fileElem.click();
        }
    }

    const cancelResult = () => {
        setConfirmDialogOpen(false);
        setUlType("");
    };

    //PDFファイル選択時
    const handleChangeFile = (newFile: any) => {
        pdfFileUpload(newFile.target.files[0]);
        newFile.target.value = "";
    };

    //Layファイル選択時
    const handleChangeLayFile = (newFile: any) => {
        layFileUpload(newFile.target.files[0]);
        newFile.target.value = "";
    };

    //ファイル保存
    const fileDownload = (file_path: string) => {
        const filePath =
            "/" +
            objLongPageParam.planAreaId +
            "/" +
            objLongPageParam.branch +
            file_path;
        (async () => {
            try {
                getFileMetadata(filePath).then((meta: any) => {
                    commonFileDownload(meta.fullPath, meta.name);
                });
            } catch (e) {
                console.log(e);
            }
        })();
    };
    
    //ファイル存在チェック
    const checkFileName = (file: any) => {
        let flag = false
        excelList.map((val:any)=>{
            if(val.file_name === file.name){
                flag = true
            }
        })
        return flag;
    };

    // PDFファイルアップロード
    const pdfFileUpload = (file: any) => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.UPLOAD_PDF);
                setMessageDialogOpen(true);
                let fileName = file.name;
                //同名のファイルがアップされている場合はアップロードファイルに日付追加
                if(checkFileName(file)){
                    const date = new Date();
                    const nowDate = date.getFullYear() + (date.getMonth() + 1).toString().padStart(2, "0") + date.getDate().toString().padStart(2, "0") + 
                                    date.getHours().toString().padStart(2, "0") + date.getMinutes().toString().padStart(2, "0") + date.getSeconds().toString().padStart(2, "0"); 
                    fileName = file.name.replace(".pdf", "") + "_" +  nowDate +".pdf";
                }
                const filePath = "/drawing/" + fileName;
                const copyData = JSON.parse(JSON.stringify(objDrawing));
                let target_column = "";
                if (["layout"].includes(targetFileType)) {
                    copyData.layout_file_path = filePath;
                    copyData.layout_file_user = userId;
                    target_column = LOCAL_CONSTANT.LABEL.LAYOUT_DIAGRAM + LOCAL_CONSTANT.LABEL.UPLOAD
                } else if (["placement"].includes(targetFileType)) {
                    copyData.placement_file_path = filePath;
                    copyData.placement_file_user = userId;
                    target_column = LOCAL_CONSTANT.LABEL.PLACEMENT_DIAGRAM + LOCAL_CONSTANT.LABEL.UPLOAD
                } else if (["designer_placement"].includes(targetFileType)) {
                    copyData.designer_placement_file_path = filePath;
                    copyData.designer_placement_file_user = userId;
                    target_column = LOCAL_CONSTANT.LABEL.DESIGNER_PLACEMENT_DIAGRAM + LOCAL_CONSTANT.LABEL.UPLOAD
                }
                await uploadFile(
                    file,
                    objLongPageParam.planAreaId +
                    "/" +
                    objLongPageParam.branch +
                    "/drawing/" +
                    fileName
                );
                const file_log = {
                    plan_area_id: objLongPageParam.planAreaId,
                    branch: objLongPageParam.branch,
                    log_type: "19",
                    target_table: LOCAL_CONSTANT.TABLE.DRAWING,
                    target_column: target_column,
                    target_before_value: "",
                    target_after_value: "",
                };
                //DB保存
                let params = upsertDrawingPathParam(
                    copyData,
                    objLongPageParam.planAreaId,
                    objLongPageParam.branch,
                    file_log
                );
                updateRegist(
                    params,
                    LOCAL_CONSTANT.FUNCTION_NAME.DRAWING_PDF_CREATE
                );
                //Redux保存
                dispatch(setObjDrawing(copyData));
                if (["layout"].includes(targetFileType)) {
                    whiteExcelList(0, filePath, userId);
                } else if (["placement"].includes(targetFileType)) {
                    whiteExcelList(1, filePath, userId);
                } else if (["designer_placement"].includes(targetFileType)) {
                    whiteExcelList(2, filePath, userId);
                }
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.SUCCESS_UPLOAD_PDF);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.ERROR_UPLOAD_PDF);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };

    const whiteExcelList = (index: number, file_path: string, user: string) => {
        const filePath =
            "/" +
            objLongPageParam.planAreaId +
            "/" +
            objLongPageParam.branch +
            file_path;
        getFileMetadata(filePath).then((meta: any) => {
            setExcelList((prevList) => {
                const updateList = [...prevList];
                updateList[index] = {
                    ...updateList[index],
                    file_name : meta.name,
                    uploadDate : dayjs(meta.updated).format(
                        "YYYY/MM/DD HH:mm:ss"
                    ),
                    uplowder : user,
                    file_path : file_path
                };
                return updateList;
            });
        });
    };

    // layファイルアップロード
    const layFileUpload = (file: any) => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.UPLOAD_FILE);
                setMessageDialogOpen(true);
                const fileName = file.name;
                const filePath = "/lay/" + ulType + "/" + fileName;
                const now = new Date();
                const upload_date = `${now.getFullYear()}/${now.getMonth()+1}/${now.getDate()} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
                const copyData = JSON.parse(JSON.stringify(objDrawing));
                const layPathParam = [{
                    "file_name": fileName,
                    "file_path": filePath,
                    "upload_date": upload_date,
                    "upload_staff_number": userId
                }];
                let target_column = "";
                if (["RFC"].includes(ulType)) {
                    if (copyData.lay_file_rfc_path.length > 0) {
                        const path =
                            objLongPageParam.planAreaId +
                            "/" +
                            objLongPageParam.branch +
                            copyData.lay_file_rfc_path[0]?.file_path;
                        const deleteFile = await getFileMetadata(path);
                        await deleteUploadFile(deleteFile, path);
                    }
                    copyData.lay_file_rfc_path = layPathParam;
                    target_column = "【RFC】" + LOCAL_CONSTANT.FUNCTION_NAME.DRAWING_LAY_UPLOAD;
                } else {
                    if (copyData.lay_file_rr_path.length > 0) {
                        const path =
                            objLongPageParam.planAreaId +
                            "/" +
                            objLongPageParam.branch +
                            copyData.lay_file_rr_path[0]?.file_path;
                        const deleteFile = await getFileMetadata(path);
                        await deleteUploadFile(deleteFile, path);
                    }
                    copyData.lay_file_rr_path = layPathParam;
                    target_column = "【RR】" + LOCAL_CONSTANT.FUNCTION_NAME.DRAWING_LAY_UPLOAD;
                }
                await uploadFile(
                    file,
                    objLongPageParam.planAreaId +
                    "/" +
                    objLongPageParam.branch +
                    "/lay/" + ulType + "/" +
                    fileName
                );
                const file_log = {
                    plan_area_id: objLongPageParam.planAreaId,
                    branch: objLongPageParam.branch,
                    log_type: "19",
                    target_table: LOCAL_CONSTANT.TABLE.DRAWING,
                    target_column: target_column,
                    target_before_value: "",
                    target_after_value: "",
                };
                //DB保存
                let params = upsertDrawingPathParam(
                    copyData,
                    objLongPageParam.planAreaId,
                    objLongPageParam.branch,
                    file_log
                );
                updateRegist(
                    params,
                    LOCAL_CONSTANT.FUNCTION_NAME.DRAWING_LAY_UPLOAD
                );
                //Redux保存
                dispatch(setObjDrawing(copyData));
                setUlType("");
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.SUCCESS_UPLOAD_FILE);
                setHasButton(true);
                setConfirmDialogOpen(false);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.ERROR_UPLOAD_FILE);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };

    //PDF削除
    const handleDeletePdfConfModalOpen = (val: any) => {
        dispatch(setDeleteFile(val));
        setDeletePdfConfModalOpen(true);
    };

    const handleDeletePdfChange = () => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.DELETE_PDF);
                setMessageDialogOpen(true);
                const copyData = JSON.parse(JSON.stringify(objDrawing));

                let target_column = "";
                if (["layout"].includes(objDeleteFile.target)) {
                    copyData.layout_file_path = "";
                    copyData.layout_file_user = "";
                    target_column = LOCAL_CONSTANT.LABEL.LAYOUT_DIAGRAM + LOCAL_CONSTANT.LABEL.DELETE
                } else if (["placement"].includes(objDeleteFile.target)) {
                    copyData.placement_file_path = "";
                    copyData.placement_file_user = "";
                    target_column = LOCAL_CONSTANT.LABEL.PLACEMENT_DIAGRAM + LOCAL_CONSTANT.LABEL.DELETE
                } else if (
                    ["designer_placement"].includes(objDeleteFile.target)
                ) {
                    copyData.designer_placement_file_path = "";
                    copyData.designer_placement_file_user = "";
                    target_column = LOCAL_CONSTANT.LABEL.DESIGNER_PLACEMENT_DIAGRAM + LOCAL_CONSTANT.LABEL.DELETE
                }
                //CloudStorageから削除対象のPDF情報を取得
                const path =
                    objLongPageParam.planAreaId +
                    "/" +
                    objLongPageParam.branch +
                    objDeleteFile.file_path;
                const deleteFile = await getFileMetadata(path);
                await deleteUploadFile(deleteFile, path);
                // //DB保存
                const file_log = {
                    plan_area_id: objLongPageParam.planAreaId,
                    branch: objLongPageParam.branch,
                    log_type: "19",
                    target_table: LOCAL_CONSTANT.TABLE.DRAWING,
                    target_column: target_column,
                    target_before_value: "",
                    target_after_value: "",
                };
                let params = upsertDrawingPathParam(
                    copyData,
                    objLongPageParam.planAreaId,
                    objLongPageParam.branch,
                    file_log
                );
                updateRegist(
                    params,
                    LOCAL_CONSTANT.FUNCTION_NAME.DRAWING_PDF_DELETE
                );
                // //Redux保存
                dispatch(setObjDrawing(copyData));
                if (["layout"].includes(objDeleteFile.target)) {
                    excelList[0] = JSON.parse(JSON.stringify(init_layout));
                } else if (["placement"].includes(objDeleteFile.target)) {
                    excelList[1] = JSON.parse(JSON.stringify(init_placement));
                } else if (
                    ["designer_placement"].includes(objDeleteFile.target)
                ) {
                    excelList[2] = JSON.parse(
                        JSON.stringify(init_designer_placement)
                    );
                }
                //プレビューを戻す
                dispatch(setDrawingPdf(""));
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.SUCCESS_DELETE_PDF);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.ERROR_DELETE_PDF);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };

    //LAY削除
    const handleDeleteLayConfModalOpen = (target: string) => {
        setUlType(target);
        setDeleteLayConfModalOpen(true);
    };

    const handleDeleteLayChange = () => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.DELETE_FILE);
                setMessageDialogOpen(true);
                const copyData = JSON.parse(JSON.stringify(objDrawing));
                let path = "";
                let target_column = "";
                if (["RFC"].includes(ulType)) {
                    path =
                        objLongPageParam.planAreaId +
                        "/" +
                        objLongPageParam.branch +
                        copyData.lay_file_rfc_path[0]?.file_path;
                    copyData.lay_file_rfc_path = [];
                    target_column = "【RFC】LAYファイル削除";
                } else {
                    path =
                        objLongPageParam.planAreaId +
                        "/" +
                        objLongPageParam.branch +
                        copyData.lay_file_rr_path[0]?.file_path;
                    copyData.lay_file_rr_path = [];
                    target_column = "【RR】LAYファイル削除";
                }
                //CloudStorageから削除対象のPDF情報を取得
                if(path !== ""){
                    const deleteFile = await getFileMetadata(path);
                    await deleteUploadFile(deleteFile, path);
                }
                // //DB保存
                const file_log = {
                    plan_area_id: objLongPageParam.planAreaId,
                    branch: objLongPageParam.branch,
                    log_type: "19",
                    target_table: LOCAL_CONSTANT.TABLE.DRAWING,
                    target_column: target_column,
                    target_before_value: "",
                    target_after_value: "",
                };
                let params = upsertDrawingPathParam(
                    copyData,
                    objLongPageParam.planAreaId,
                    objLongPageParam.branch,
                    file_log
                );
                updateRegist(
                    params,
                    LOCAL_CONSTANT.FUNCTION_NAME.DRAWING_LAY_DELETE
                );
                // //Redux保存
                dispatch(setObjDrawing(copyData));
                setUlType("");
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.SUCCESS_DELETE_FILE);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.ERROR_DELETE_FILE);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };

    const updateRegist = (params: any, function_name: string) => {
        userLogging(function_name, params, user);
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                await apiRequest(params);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };

    // 吹き出しをクリックしたとき、モーダル画面を開く
    const handleChatBubbleClick = (labelName: string) => {
        setLabelNameStr(labelName);
        setDeficiencyComentModalFlag(true);
        setDrawingCommentTextFieldObj({
            ...drawingCommentTextFieldObj,
            [labelName]: "",
        }); //テキストフィールドのコメントを初期化
    };

    // モーダル内でのコメント取得
    const handleCommentChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        labelName: string
    ) => {
        setDrawingCommentTextFieldObj({
            ...drawingCommentTextFieldObj,
            [labelName]: e.target.value,
        });
    };

    // モーダル内の保存ボタンをクリックしたときコメントを保存
    const handleSaveComment = async (labelName: string) => {
        //不備コメントを登録
        const params = {
            mode: "regist",
            endPoint: "/location/Deficiency/v1/regist",
            query: {
                plan_area_id: objLongPageParam.planAreaId,
                branch: objLongPageParam.branch,
                status_seq: objLocationBase.status_seq,
                table_name: LOCAL_CONSTANT.TABLE.DRAWING,
                column_name: labelName,
                comment: drawingCommentTextFieldObj[labelName],
                sub_key: LOCAL_CONSTANT.DEFICIENCY.DEFAULT_SUB_KEY
            },
        };
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        try {
            await apiRequest(params);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
            //不備コメントモーダルを閉じる
            setDeficiencyComentModalFlag(false);
        } catch (e) {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
            //不備コメントモーダルを閉じる
            setDeficiencyComentModalFlag(false);
        }
    };

    //ユーザーIDを取得タイミングによる画面制御
    useEffect(() => {
        if (JSON.parse(user.userData || "null") !== null) {
            setUserId(JSON.parse(user.userData || "null").staff_number);
            setUserType(JSON.parse(user.userData || "null").user_type);
        }
    }, [user]);

    return (
        <Box style={{ width: "100%", margin: "30px" }}>
            <Grid container spacing={1}>
                <Grid item xs={12} sx={{ paddingRight: "40px" }}>
                    <MessageDialog
                        props={{
                            open: messageDialogOpen,
                            handleModal: closeMessageDialog,
                            body: message,
                            hasButton: hasButton,
                            buttonBody: LOCAL_CONSTANT.LABEL.CLOSE,
                        }}
                    />
                    <input
                        id="drawingFileElem"
                        type="file"
                        style={{ display: "none" }}
                        onChange={handleChangeFile}
                        accept=".pdf"
                    />
                    <input
                        id="drawingLayFileElem"
                        type="file"
                        style={{ display: "none" }}
                        onChange={handleChangeLayFile}
                        accept=".lay"
                    />
                    <Button
                        sx={{ margin: "20px 10px 20px 0" }}
                        variant="contained"
                        color="success"
                        size="small"
                        onClick={(e) => {handleClickPdfFile("layout");}}
                        disabled={setPermissionFunc(
                            userType,
                            objLocationBase.task_id,
                            LOCAL_CONSTANT.NAVI.DRAWING,
                            "uploadButton"
                        )}
                    >
                        {LOCAL_CONSTANT.LABEL.LAYOUT_DIAGRAM}
                    </Button>
                    <Button
                        sx={{ margin: "20px 10px" }}
                        variant="contained"
                        color="success"
                        size="small"
                        onClick={(e) => {handleClickPdfFile("placement");}}
                        disabled={setPermissionFunc(
                            userType,
                            objLocationBase.task_id,
                            LOCAL_CONSTANT.NAVI.DRAWING,
                            "uploadButton"
                        )}
                    >
                        {LOCAL_CONSTANT.LABEL.PLACEMENT_DIAGRAM}
                    </Button>
                    <Button
                        sx={{ margin: "20px 10px" }}
                        variant="contained"
                        color="success"
                        size="small"
                        onClick={(e) => {
                            handleClickPdfFile("designer_placement");
                        }}
                        disabled={setPermissionFunc(
                            userType,
                            objLocationBase.task_id,
                            LOCAL_CONSTANT.NAVI.DRAWING,
                            "uploadButton"
                        )}
                    >
                        {LOCAL_CONSTANT.LABEL.DESIGNER_PLACEMENT_DIAGRAM}
                    </Button>
                    {/* RFCとRR場合、不備コメント 吹き出しアイコンを表示 */}
                    {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && 
                        <IconButton
                            disabled={setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.DRAWING, 'drawing_upload')}
                            onClick={() => { handleChatBubbleClick('drawing_upload') }}
                            sx={iconHover}
                        >
                            <Box
                                sx={chatBubbleErrorSx(
                                    userType,
                                    objLocationBase.task_id,
                                    LOCAL_CONSTANT.NAVI.DRAWING,
                                    "drawing_upload",
                                    listDeficiencyComment
                                )}
                            >
                                <ChatBubbleIcon sx={chatBubbleIconSx} />
                            </Box>
                        </IconButton>
                    }
                    <Button
                        sx={{ margin: "20px 0px 20px 10px", float: "right" }}
                        variant="contained"
                        color="success"
                        size="small"
                        onClick={() => { window.open(process.env.REACT_APP_CAD_LINK); }}
                    >
                        {LOCAL_CONSTANT.LABEL.SIMPLE_CAD_LINK_BUTTON}
                    </Button>
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item xs={12} sx={{ paddingRight: "40px" }}>
                    <TableContainer sx={{ width: "100%", border: "1px solid black" }}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={headerCell("FILE_NAME")}>{LOCAL_CONSTANT.LABEL.FILE_NAME}</TableCell>
                                    <TableCell sx={headerCell("UPLOAD_DATE")}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                    <TableCell sx={headerCell("UPLOADER")}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                    <TableCell sx={headerCell("OTHER")}></TableCell>
                                    <TableCell sx={headerCell("OTHER")}></TableCell>
                                    <TableCell sx={headerCell("OTHER")}></TableCell>
                                    <TableCell sx={headerCell("OTHER")}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {excelList.map((val, index) => (
                                    <TableRow className="tableRow" key={index}>
                                        <TableCell onClick={() => handlePreviewChange(val.file_path)}>
                                            {val.file_name}
                                        </TableCell>
                                        <TableCell onClick={() => handlePreviewChange(val.file_path)}>
                                            {val.uploadDate}
                                        </TableCell>
                                        <TableCell onClick={() => handlePreviewChange(val.file_path)}>
                                            {staffName(val.uplowder)}
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                            {val.file_path != "" && (
                                                <IconButton
                                                    sx={{ color: 'black' }} 
                                                    onClick={() =>
                                                        handlePdfPreviewModalOpen(
                                                            "/" +
                                                            objLongPageParam.planAreaId +
                                                            "/" +
                                                            objLongPageParam.branch +
                                                            val.file_path
                                                        )
                                                    }
                                                >
                                                    <PictureAsPdfIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                            {val.file_path != "" && (
                                                <IconButton
                                                    sx={{ color: 'black' }} 
                                                    onClick={() =>
                                                        handlePdfPreviewScreenOpen(
                                                            "/" +
                                                            objLongPageParam.planAreaId +
                                                            "/" +
                                                            objLongPageParam.branch +
                                                            val.file_path
                                                        )
                                                    }
                                                >
                                                    <OpenInNewIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                            {val.file_path != "" && (
                                                <IconButton
                                                    sx={{ color: "black" }}
                                                    onClick={() => fileDownload(val.file_path)}
                                                    ><DownloadIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                            {val.file_path != "" && (
                                                <IconButton
                                                    sx={{ color: "black" }}
                                                    disabled={setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.DRAWING, 'deleteButton')}
                                                    onClick={() => handleDeletePdfConfModalOpen(val)}
                                                    ><DeleteIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>

            {/* プレビュー */}
            {previewPdfPath !== "" && (
                <Box sx={{ padding: "30px 40px 0px 0px" }}>
                    <PdfViewer props={{ pdfPath: previewPdfPath }} />
                </Box>
            )}

            {/* PDFプレビューモーダル */}
            <PdfViewerModal
                props={{
                    open: pdfPreviewModalFlag,
                    setOpen: setPdfPreviewModalFlag,
                    pdfPath: previewPdfPath,
                }}
            />

            {/* LAYファイル */}
            <Box>
                <Button
                    sx={{ margin: "20px 10px 20px 0" }}
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={(e) => {handleClickLayFile("RFC");}}
                    disabled={setPermissionFunc(
                        userType,
                        objLocationBase.task_id,
                        LOCAL_CONSTANT.NAVI.DRAWING,
                        "rfcUploadLayButton"
                    )}
                >
                    {LOCAL_CONSTANT.LABEL.LAY_FILE_UL_BOUTTON}
                </Button>
            </Box>
            <Grid container spacing={1}>
                <Grid item xs={12} sx={{ paddingRight: "40px" }}>
                    <TableContainer sx={{ height: "132px", width: "100%", border: "1px solid black" }}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={headerCell("FILE_NAME")}>{LOCAL_CONSTANT.LABEL.FILE_NAME}</TableCell>
                                    <TableCell sx={headerCell("UPLOAD_DATE")}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                    <TableCell sx={headerCell("UPLOADER")}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                    <TableCell sx={headerCell("OTHER")}></TableCell>
                                    <TableCell sx={headerCell("OTHER")}></TableCell>
                                    <TableCell sx={headerCell("OTHER")}></TableCell>
                                    <TableCell sx={headerCell("OTHER")}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {layRfcFileList.map((val, index) => (
                                    <TableRow className="tableRow" key={index}>
                                        <TableCell>
                                            {val.file_name}
                                        </TableCell>
                                        <TableCell>
                                            {val.upload_date}
                                        </TableCell>
                                        <TableCell>
                                            {staffName(val.upload_staff_number)}
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                            {val.file_path != "" && (
                                                <IconButton
                                                    sx={{ color: "black" }}
                                                    onClick={() => fileDownload(val.file_path)}
                                                    ><DownloadIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                            {val.file_path != "" && (
                                                <IconButton
                                                    sx={{ color: "black" }}
                                                    disabled={setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.DRAWING, 'deleteButton')}
                                                    onClick={() => handleDeleteLayConfModalOpen("RFC")}
                                                    ><DeleteIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>

            {/* LAYファイル(RR権限) */}
            {LOCAL_CONSTANT.USER_TYPE.RR.includes(userType) && 
                <>
                    <Box>
                        <Button
                            sx={{ margin: "20px 10px 20px 0" }}
                            variant="contained"
                            color="success"
                            size="small"
                            onClick={(e) => {handleClickLayFile("RR");}}
                            disabled={setPermissionFunc(
                                userType,
                                objLocationBase.task_id,
                                LOCAL_CONSTANT.NAVI.DRAWING,
                                "rrUploadLayButton"
                            )}
                        >
                            {LOCAL_CONSTANT.LABEL.LAY_FILE_RR_UL_BOUTTON}
                        </Button>
                    </Box>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sx={{ paddingRight: "40px" }}>
                            <TableContainer sx={{ height: "132px", width: "100%", border: "1px solid black" }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={headerCell("FILE_NAME")}>{LOCAL_CONSTANT.LABEL.FILE_NAME}</TableCell>
                                            <TableCell sx={headerCell("UPLOAD_DATE")}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                            <TableCell sx={headerCell("UPLOADER")}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {layRrFileList.map((val, index) => (
                                            <TableRow className="tableRow" key={index}>
                                                <TableCell>
                                                    {val.file_name}
                                                </TableCell>
                                                <TableCell>
                                                    {val.upload_date}
                                                </TableCell>
                                                <TableCell>
                                                    {staffName(val.upload_staff_number)}
                                                </TableCell>
                                                <TableCell sx={{ textAlign: "center" }}>
                                                </TableCell>
                                                <TableCell sx={{ textAlign: "center" }}>
                                                </TableCell>
                                                <TableCell sx={{ textAlign: "center" }}>
                                                    {val.file_path != "" && (
                                                        <IconButton
                                                            sx={{ color: "black" }}
                                                            onClick={() => fileDownload(val.file_path)}
                                                            ><DownloadIcon />
                                                        </IconButton>
                                                    )}
                                                </TableCell>
                                                <TableCell sx={{ textAlign: "center" }}>
                                                    {val.file_path != "" && (
                                                        <IconButton
                                                            sx={{ color: "black" }}
                                                            disabled={setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.DRAWING, 'deleteButton')}
                                                            onClick={() => handleDeleteLayConfModalOpen("RR")}
                                                            ><DeleteIcon />
                                                        </IconButton>
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </>
            }

            <ObstaclesEtc props={{}} />

            {/* PAFファイル削除確認モーダル */}
            <DeleteConfirmationModal
                modalOpen={deletePdfConfModalOpen}
                setModalOpen={setDeletePdfConfModalOpen}
                deleteMethod={handleDeletePdfChange}
            />

            {/* LAYファイル削除確認モーダル */}
            <DeleteConfirmationModal
                modalOpen={deleteLayConfModalOpen}
                setModalOpen={setDeleteLayConfModalOpen}
                deleteMethod={handleDeleteLayChange}
            />

            {/* LAYファイルUL確認用モーダル */}
            <ConfirmDialog
                props={{
                    open: confirmDialogOpen,
                    handleModal: setConfirmDialogOpen,
                    onCancel: cancelResult,
                    onExecution: handleOkResult,
                    mode: "",
                    body: LOCAL_CONSTANT.CONFIRM_MESSAGE.FILE_UPLOAD_CONFIRM,
                    confirmCancel: LOCAL_CONSTANT.LABEL.CANCEL,
                    confirmOk: LOCAL_CONSTANT.LABEL.UPLOAD,
                }}
            />

            {/*不備コメント モーダル画面 */}
            <DeficiencyCommentRegistModal
                props={{
                    userType: userType,
                    modalOpen: deficiencyComentModalFlag,
                    setModalOpen: setDeficiencyComentModalFlag,
                    CommentTextFieldObj: drawingCommentTextFieldObj,
                    tableName: LOCAL_CONSTANT.TABLE.DRAWING,
                    columnName: labelNameStr,
                    subKey: LOCAL_CONSTANT.DEFICIENCY.DEFAULT_SUB_KEY,
                    handleCommentChange: handleCommentChange,
                    handleSaveComment: handleSaveComment,
                }}
            />
        </Box>
    );
};

export default Drawing;
